import { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';

interface SimMenuProps {
  simulationId: string;
  devMode: boolean;
  onDevModeChange: (v: boolean) => void;
  onCopyId: () => void;
  onCopyLink: () => void;
}

export function SimMenu({ devMode, onDevModeChange, onCopyId, onCopyLink }: SimMenuProps) {
  const [open, setOpen] = useState(false);
  const [dropdownPos, setDropdownPos] = useState({ top: 0, right: 0 });
  const triggerRef = useRef<HTMLDivElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const handleOutside = (e: MouseEvent | TouchEvent) => {
      const t = e.target as Node;
      if (!triggerRef.current?.contains(t) && !dropdownRef.current?.contains(t)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleOutside);
    document.addEventListener('touchstart', handleOutside);
    return () => {
      document.removeEventListener('mousedown', handleOutside);
      document.removeEventListener('touchstart', handleOutside);
    };
  }, [open]);

  const handleTrigger = () => {
    if (!open && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setDropdownPos({ top: rect.bottom + 8, right: window.innerWidth - rect.right });
    }
    setOpen(o => !o);
  };

  const dropdownStyle: React.CSSProperties = {
    position: 'fixed',
    top: dropdownPos.top,
    right: dropdownPos.right,
    zIndex: 1000,
  };

  return (
    <>
      <div className="user-menu-section" ref={triggerRef}>
        <div className="user-menu-trigger" onClick={handleTrigger}>
          <span className="username">SIM</span>
          <span className="menu-arrow">{open ? '▲' : '▼'}</span>
        </div>
      </div>

      {open && ReactDOM.createPortal(
        <div className="user-dropdown" style={dropdownStyle} ref={dropdownRef}>
          <div className="dropdown-item" onClick={() => { onCopyId(); setOpen(false); }}>
            COPY ID
          </div>
          <div className="dropdown-item" onClick={() => { onCopyLink(); setOpen(false); }}>
            COPY LINK
          </div>
          <div
            className="dropdown-item"
            onClick={() => onDevModeChange(!devMode)}
          >
            DEV MODE
            <span style={{
              marginLeft: 'auto',
              paddingLeft: '1rem',
              color: devMode ? 'var(--primary)' : 'var(--text-muted)',
              fontWeight: devMode ? 700 : 400,
            }}>
              {devMode ? 'ON' : 'OFF'}
            </span>
          </div>
        </div>,
        document.body
      )}
    </>
  );
}
